import React from "react";
import { REVIEWS_STORE } from "utils/constants";
import { useInView } from "react-intersection-observer";
import { useGlobalContext } from "context/global";
import { formatTitle } from "helpers/format-title";

const StoreReviews = ({ data }) => {
	const [inView, ratingsInView] = useInView({
		threshold: 0,
		rootMargin: "50px",
		triggerOnce: true,
	});

	const { langCode } = useGlobalContext();

	// eslint-disable-next-line no-undef
	ratingsInView && new ReviewsWidget("#ReviewsWidget", {
		store: REVIEWS_STORE,
		widget: "polaris",
		options: {
			types: data.reviews,
			per_page: data?.amount,
			lang: langCode,
			product_review: {
				min_rating: 1, 
				enable_rich_snippets: false,
				structured_data: {
					category: null,
					url: REVIEWS_STORE,
					description: "",
					brand: {
						type: "Brand",
						name: "",
					},
				},
			},
			store_review: {
				min_rating: 1, 
				enable_rich_snippets: false,
				structured_data: {
					category: null,
					url: REVIEWS_STORE,
					description: "",
					brand: {
						type: "Brand",
						name: "",
					},
				},
			},

			//Header settings:
			header: {
				enable_summary: true, 
				enable_ratings: true,
				enable_attributes: true,
				enable_percent_recommended: false, //Show what percentage of reviewers recommend it
				enable_write_review: true, //Show "Write Review" button
				enable_sub_header: true, //Show subheader
				show_rating_threshold_percent: 0,
			},

			//Filtering settings:
			filtering: {
				enable: true, //Show filtering options
				enable_text_search: true, //Show search field
				enable_sorting: true, //Show sorting options (most recent, most popular)
				enable_overall_rating_filter: true, //Show overall rating breakdown filter
				enable_ratings_filters: true, //Show product attributes filter
				enable_attributes_filters: true, //Show author attributes filter
			},

			//Review settings:
			reviews: {
				enable_avatar: true, //Show author avatar
				enable_reviewer_name: true, //Show author name
				enable_reviewer_address: true, //Show author location
				reviewer_address_format: "city", //Author location display format
				enable_verified_badge: true, //Show "Verified Customer" badge
				enable_reviewer_recommends: true, //Show "I recommend it" badge
				enable_attributes: true, //Show author attributes
				enable_replies: true, //Show review replies
				enable_product_name: true, //Show display product name
				enable_images: true, //Show display review photos
				enable_ratings: true, //Show product attributes (additional ratings)
				enable_share: true, //Show share buttons
				enable_helpful_vote: true, //Show "was this helpful?" section
				enable_helpful_display: true, //Show how many times times review upvoted
				enable_report: true, //Show report button
				enable_date: true, //Show when review was published
				// review_content_filter: "no_comments",
			},
			text: { "Verified Customer": "Verified Customer" },
		},

		translations: { "Verified Customer": "Verified Customer" },
	});

	return <section className="w-full mx-auto px-8">
		{data?.title && <h2 className="text-center mb-6 md:mb-12">{formatTitle(data.title)}</h2>}
		<div ref={inView} id="ReviewsWidget"></div>
	</section>;

};

export default StoreReviews;